(function () {
  'use strict'
  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers')
    .controller('IntegrationsConfigsController', integrationsconfigsController)

  integrationsconfigsController.$inject = ['$scope', 'FoundationApi', 'ngTableParams', 'IntegrationsConfigsService', 'NotificationService']
  function integrationsconfigsController ($scope, FoundationApi, ngTableParams, IntegrationsConfigsService, NotificationService) {
    var vm = this
    vm.script = ''
    vm.edit = edit
    vm.add = add
    vm.saveConfig = saveConfig
    vm.titlePage = 'Configurações'
    vm.totalLang = 0
    vm.closeConfig = closeConfig
    vm.confirmDelete = confirmDelete
    vm.deleteConfig = deleteConfig

    vm.filters = {
      page: ''
    }

    getConfigs()

    function getConfigs () {
      vm.configsTable = new ngTableParams(
        {
          count: 50
        },
        {
          counts: [
            25, 50, 100
          ],
          getData: function ($defer, params) {
            var obj = params.url()
            IntegrationsConfigsService
              .getConfigs(obj)
              .$promise
              .then(function (data) {
                $defer.resolve(data.response.data)
                if (data.success) {
                  vm.totalLang = data.response.data.length
                } else {
                  NotificationService.errorHandler(data, 'Erro durante a comunicação com a API!')
                  vm.totalLang = 0
                }
              }).catch(function (data) {
                NotificationService.errorHandler(data, 'Erro ao carregar as Configurações!')
                vm.totalLang = 0
              })
          }
        }
      )
    }

    function saveConfig () {
      try {
        if (vm.script !== '') {
          let obj = JSON.parse(vm.script)
          IntegrationsConfigsService
            .saveConfig(obj)
            .$promise
            .then(function (data) {
              getConfigs()
              NotificationService.successHandler(data, 'Configuração salva com sucesso!')
              FoundationApi.publish('configModal', 'close')
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao salvar configurações!')
            })
        } else {
          NotificationService.errorHandler('Nenhum dado informado!', 'Nenhum dado informado!')
        }
      } catch (data) {
        NotificationService.errorHandler(data, 'Configuração inválida!')
      }
    }

    $scope.updateConfigObject = function () {
      if (vm.script !== '') {
        try {
          $scope.message = JSON.parse(vm.script)
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' }
          vm.configValid = true
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' }
          vm.configValid = false
        }
      } else {
        $scope.formatting = {}
      }
    }

    function add () {
      document.getElementById('scriptMongoDB').readOnly = false
      vm.backupDialog = false
      vm.script = ''
      FoundationApi.publish('configModal', 'open')
      $scope.updateConfigObject()
    }

    function edit (config) {
      document.getElementById('scriptMongoDB').readOnly = false
      vm.backupDialog = false
      vm.script = JSON.stringify(config, null, 2)
      $scope.updateConfigObject()
      FoundationApi.publish('configModal', 'open')
    }

    function closeConfig () {
      FoundationApi.publish('configModal', 'close')
    }

    function confirmDelete (config) {
      vm.deleting = config
      FoundationApi.publish('confirmDeleteModal', 'open')
    }

    function deleteConfig (config) {
      IntegrationsConfigsService
        .deleteConfigs(config)
        .$promise
        .then(function (data) {
          getConfigs()
          if (data.success) {
            NotificationService.successHandler(data, 'Configuração removida com sucesso')
            FoundationApi.publish('confirmDeleteModal', 'close')
          } else {
            NotificationService.errorHandler(data, 'Erro ao apagar configuração!')
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao apagar configuração!')
        })
    }
  }
// eslint-disable-next-line semi
})();
